import { jwtVerify } from "jose";

function pemToArrayBuffer(pem: string) {
  const b64 = pem.replace(/-----.*?-----/g, "").replace(/\s/g, "");
  const binary = atob(b64);
  const buffer = new ArrayBuffer(binary.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binary.length; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return buffer;
}

async function importPublicKey(pem: string) {
  const binaryKey = pemToArrayBuffer(pem);
  return await crypto.subtle.importKey(
    "spki",
    binaryKey,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: "SHA-256",
    },
    false,
    ["verify"]
  );
}

export async function verifyToken(token: string, pemKey: string) {
  try {
    const publicKey = await importPublicKey(pemKey);
    const { payload } = await jwtVerify(token, publicKey);
    return payload;
  } catch (err) {
    return false;
  }
}
